interface LearnosityScores {
  [key: string]: {
    score: number;
    max_score: number;
  }[];
}

export const getLocalScores = (scores: LearnosityScores): [number, number][] => {
  const localScores: [number, number][] = [];
  Object.values(scores).forEach((value: any) => {
    localScores.push([value.score, value.max_score]);
  });
  return localScores;
};

export const isCorrectAnswer = (score: [number, number]) => {
  return score[0] === score[1]; // a correct answer is `score` equals to `max_score`
};

export const shouldStopTest = (
  scores: [number, number][],
  allowedConsecutiveFails: number,
  isSkippedQuestionAWrongQuestion: boolean,
) => {
  // note: s[0] === null if student didnt answered it yet
  const answeredScores = isSkippedQuestionAWrongQuestion
    ? scores
    : scores.filter((s) => s[0] !== null);

  if (!allowedConsecutiveFails) {
    return false;
  }

  let consecutiveFails = 0;
  for (let i = 0; i < answeredScores.length; i++) {
    if (!isCorrectAnswer(answeredScores[i])) {
      consecutiveFails++;
    } else {
      consecutiveFails = 0;
    }
    if (consecutiveFails > allowedConsecutiveFails) {
      return true;
    }
  }
  return false;
};

export const submitSettings = {
  show_submit_confirmation: false,
  show_submit_ui: true,
};
